var _module = require('../module');

require('angular-input-masks');
require('../../services/login-or-register-modal');
require('../../services/analytics');

_module.requires.push('ui.utils.masks');

_module.component('mobileAlertsBanner', {
    bindings: {
        source: '@'
    },
    controllerAs: 'mab',
    controller: [
        '$log',
        '$loginOrRegisterModal',
        '$analytics',

        function mobileAlertsBannerCtrl($log, $loginOrRegisterModal, $analytics) {
            var _this = this;

            this.phone = '';

            // Functions
            this.open = function open() {
                if(_this.phone) {
                    $analytics.eventTrack('Mobile Alerts Banner Submit', {
                        Source: this.source
                    });

                    $loginOrRegisterModal({ phone: _this.phone });
                }
            };
        }
    ],
    template: require('./index.html')
});
